import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCloudySparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cloudy-sparkle, clouds"><path d="M18.5 19.0615C20.6627 18.4544 22.25 16.4502 22.25 14.0714C22.25 11.2114 19.9555 8.89286 17.125 8.89286C16.5661 8.89286 16.0281 8.98326 15.5245 9.15037C14.4289 6.56294 11.8865 4.75 8.925 4.75C4.96236 4.75 1.75 7.99594 1.75 12C1.75 14.7508 3.26609 17.1437 5.5 18.3722" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.4 14H11.6L10.6 16.6L8 17.6V18.4L10.6 19.4L11.6 22H12.4L13.4 19.4L16 18.4V17.6L13.4 16.6L12.4 14Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCloudySparkle;
